import { jsx } from 'react/jsx-runtime';
import { getSentryHub } from '../../utils/sentryHub.js';
import HeaderAccountFlyoutComponent from './HeaderAccountFlyoutComponent.js';
import { ErrorBoundary } from '../../node_modules/@zooplus/myaccount-utils/dist/es/components/ErrorBoundary/ErrorBoundary.js';

const HeaderAccountFlyout = ({ locale, bundle, domain, hasBonusPoints, onFlyoutClick, }) => {
    return (jsx(ErrorBoundary, { showNotification: false, withSentryHub: getSentryHub, children: jsx(HeaderAccountFlyoutComponent, { locale: locale, bundle: bundle, domain: domain, hasBonusPoints: hasBonusPoints, onFlyoutClick: onFlyoutClick }) }));
};
HeaderAccountFlyout.displayName = 'HeaderAccountFlyout';

export { HeaderAccountFlyout as default };
//# sourceMappingURL=HeaderAccountFlyout.js.map
